import { pick } from 'ramda';
import { useMemo, useCallback } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';

import { UNLIMITED_DATE_VALUE } from '../constants';
import { useDynamicReducerSelector } from '../store';

export const useLimits = ({ translate }) => {
    const formatter = useFormatter();
    const { limit, amountToBeLeftOnBalance } = useDynamicReducerSelector(pick([
        'limit', 'amountToBeLeftOnBalance'
    ]));

    const getLimitEndDate = useCallback((date) => {
        if (!date) {
            return '';
        }

        const parsedDate = date && formatter.parseImsDate(date);
        const isDateUnlimited = UNLIMITED_DATE_VALUE <= new Date(parsedDate).getFullYear();

        return isDateUnlimited
            ? translate('unlimited')
            : `${translate('till')} ${formatter.getDateTimeShort(parsedDate)}`;
    }, [translate, formatter]);

    return useMemo(() => ({
        limit: {
            amount: limit.amount,
            endDate: getLimitEndDate(limit.endDate),
            currencyCode: formatter.getCurrencySymbol(limit.currencyCode)
        },
        amountToBeLeftOnBalance: {
            amount: amountToBeLeftOnBalance.amount,
            endDate: getLimitEndDate(amountToBeLeftOnBalance.endDate),
            currencyCode: formatter.getCurrencySymbol(amountToBeLeftOnBalance.currencyCode)
        }
    }), [limit, amountToBeLeftOnBalance, getLimitEndDate, formatter]);
};
